import {mixins} from "../app/mixin";

mixins.push({
    el: '.blogPage',
    data() {
        return {
            isLoading: false,
            pages: window.pages
        };
    },
    methods: {
        nextPage(index) {
            if (this.pages[index].currentPage < this.pages[index].totalPages) {
                this.pages[index].currentPage++;
                this.pages[index].minIndex = (this.pages[index].currentPage - 1) * this.pages[index].postPerPage;
                this.pages[index].maxIndex = ((this.pages[index].currentPage - 1) * this.pages[index].postPerPage) + this.pages[index].postPerPage;
            }
        },
        prevPage(index) {
            if (this.pages[index].currentPage > 1) {
                this.pages[index].currentPage--;
                this.pages[index].minIndex = (this.pages[index].currentPage - 1) * this.pages[index].postPerPage;
                this.pages[index].maxIndex = ((this.pages[index].currentPage - 1) * this.pages[index].postPerPage) + this.pages[index].postPerPage;
            }
        },
        isMobile() {
            return window.innerHeight > window.innerWidth; //todo
        },
        showLoading() {
            this.isLoading = true;
            document.body.style.overflow = 'hidden';
        },
        hideLoading() {
            this.isLoading = false;
            document.body.style.overflow = 'auto';
        }
    },
    mounted() {
        if (this.isMobile()) {
            this.showLoading();

            setTimeout(() => {
                this.hideLoading();
            } , 5000);

            for (let page of this.pages) {
                page.maxIndex = 1;
                page.postPerPage = 1;
                page.totalPages = page.totalItems;
            }
        }
    }
});